module.exports = __webpack_public_path__ + "static/media/clam.a6e7da7a.png";